import useReveal from "@/hooks/useReveal";

const CATEGORIES = [
  {
    no: "01",
    title: "Luxury Hotels",
    copy: "Five-star marquee properties seeking uniform programmes that mirror exacting design standards.",
    featured: true,
  },
  {
    no: "02",
    title: "4-Star Hospitality Chains",
    copy: "Multi-property groups requiring consistent, scalable rollouts across cities and formats.",
  },
  {
    no: "03",
    title: "Boutique Hotels",
    copy: "Story-led independent properties where every detail signals a singular point of view.",
  },
  {
    no: "04",
    title: "Premium Restaurants",
    copy: "Fine dining and chef-led concepts where staff attire reads as part of the cuisine.",
  },
  {
    no: "05",
    title: "Hospitality Rebrands",
    copy: "Established properties evolving their identity, with uniforms as a tactile pillar of change.",
  },
  {
    no: "06",
    title: "Pre-Opening Projects",
    copy: "New launches that require a complete uniform programme aligned with brand at day one.",
    featured: true,
  },
];

function Segment({ c, delay }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`segment-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`reveal reveal-delay-${delay} group relative p-10 md:p-12 transition-all duration-700 ${
        c.featured
          ? "bg-bone border-2 border-oxblood/80 shadow-[0_2px_0_#DCD3C6]"
          : "border-r border-b border-borderwarm hover:bg-bone-200/70"
      }`}
    >
      {c.featured && (
        <span
          data-testid={`featured-tag-${c.no}`}
          className="absolute top-5 right-5 text-[9px] uppercase tracking-[0.32em] text-oxblood font-medium"
        >
          Featured
        </span>
      )}
      <div className="flex items-baseline justify-between mb-8">
        <span className="font-serif text-2xl text-champagne-dark">{c.no}</span>
        <span className={`h-px w-12 ${c.featured ? "bg-oxblood/40" : "bg-borderwarm"} group-hover:w-16 group-hover:bg-oxblood transition-all duration-700`} />
      </div>
      <h3
        className={`font-serif text-[26px] md:text-[30px] leading-tight tracking-tight ${
          c.featured ? "text-espresso font-medium" : "text-espresso/85 font-normal"
        }`}
      >
        {c.title}
      </h3>
      <p className="mt-4 text-[14px] md:text-[15px] leading-relaxed text-espresso-soft font-light">
        {c.copy}
      </p>
    </div>
  );
}

export default function WhoWeServe() {
  const headRef = useReveal();
  return (
    <section data-testid="who-we-serve" className="py-28 md:py-40">
      <div className="container-luxury">
        <div ref={headRef} className="reveal max-w-3xl">
          <div className="overline mb-6">Who We Serve</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[58px] leading-[1.06] text-espresso tracking-tight text-balance">
            Designed for properties that take
            <em className="italic text-oxblood"> every detail </em>
            seriously.
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-borderwarm">
          {CATEGORIES.map((c, i) => (
            <Segment key={c.title} c={c} delay={(i % 4) + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}
